import React from 'react'

const CategoryButton = ({className, category, onChangeCategory}) => {
  return (
 <button className={className} onClick={()=>{onChangeCategory(category)}}> {category}</button>
  )
}

export default CategoryButton
